import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {TemplateStopService} from '../services/backend/templateStopService';

export default function useLoadTemplateStopTourByIdCache() {
  const [loadingSelectedTour, setLoadingSelectedTour] = useState(false);
  const [selectedTour, setSelectedTour] = useState(null);
  const [cache, setCache] = useState({});

  const {t} = useTranslation();

  const getTourById = (tourId) => {
    resetSelectedTour();
    if (cache[tourId.toString()]) {
      setSelectedTour(cache[tourId.toString()]);
    } else {
      setLoadingSelectedTour(true);
      TemplateStopService.getTourById(tourId).then(response => {
        response.templateStopInstances = response.templateStopInstances.sort((a, b) => a.stopNumber - b.stopNumber);
        setSelectedTour(response);
        setCache({...cache, [response.id.toString()]: response});
        setLoadingSelectedTour(false);
      }, () => {
        setLoadingSelectedTour(false);
        alert(t('errorLoadingTour'))
      })
    }
  };

  const resetLoadTourByIdCache = () => {
    setCache({});
  };

  const resetSelectedTour = () => {
    setSelectedTour(null);
  };

  const updateCache = (tour) => {
    tour.templateStopInstances = tour.templateStopInstances.sort((a, b) => a.stopNumber - b.stopNumber);
    setCache({...cache, [tour.id.toString()]: tour});
    if (selectedTour && selectedTour.ud === tour.id) {
      setSelectedTour(tour);
    }
  };

  const updateMultiple = (tours) => {
    const newCache = JSON.parse(JSON.stringify(cache));
    tours.forEach(tour => {
      tour.templateStopInstances = tour.templateStopInstances.sort((a, b) => a.stopNumber - b.stopNumber);
      newCache[tour.id.toString()] = tour;
      if (selectedTour && selectedTour.id === tour.id) {
        setSelectedTour(tour);
      }
    });
    setCache(newCache);
  };

  return {selectedTour, loadingSelectedTour, getTourById, resetLoadTourByIdCache, resetSelectedTour, updateCache, updateMultiple};
}
